export default "__VITE_ASSET__9kBTUqaINCHDANxrI10WCw__";